module.exports = __webpack_public_path__ + "static/media/pic-ht2.3d21ce75.jpg";